import { TYPES } from './findUsersActions';

const initialState = {
  loading: false,
  error: null,
  searchUserText: '',
  usersFound: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SEARCH_USERS:
      return {
        ...state,
        searchUserText: action.searchUserText,
        loading: true,
        error: null,
      };
    case TYPES.SEARCH_USERS_RESULTS:
        console.log('reducer search results', action);
      return {
        ...state,
        usersFound: action.results,
        loading: false,
        error: action.error,
      };
    default:
      return { ...state };
  }
};

export default reducer;
